import { useEffect } from "react";

const getOrCreateMetaTag = (key, value, attribute = "name") => {
    let element = document.head.querySelector(`meta[${attribute}="${key}"]`);

    if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
    }

    element.setAttribute("content", value);
    return element;
};

const removeMetaTag = (key, attribute = "name") => {
    const element = document.head.querySelector(`meta[${attribute}="${key}"]`);
    if (element) {
        element.remove();
    }
};

const getOrCreateCanonicalLink = () => {
    let link = document.head.querySelector('link[rel="canonical"]');

    if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
    }

    return link;
};

const getOrCreateJsonLdScript = () => {
    let script = document.head.querySelector('script[data-seo-jsonld="true"]');

    if (!script) {
        script = document.createElement("script");
        script.setAttribute("type", "application/ld+json");
        script.setAttribute("data-seo-jsonld", "true");
        document.head.appendChild(script);
    }

    return script;
};

const removeJsonLdScript = () => {
    const script = document.head.querySelector('script[data-seo-jsonld="true"]');
    if (script) {
        script.remove();
    }
};

const Seo = ({
    title,
    description,
    canonical,
    ogImage,
    noindex = false,
    jsonLd = null,
}) => {
    useEffect(() => {
        if (title) {
            document.title = title;
            getOrCreateMetaTag("og:title", title, "property");
        } else {
            removeMetaTag("og:title", "property");
        }

        if (description) {
            getOrCreateMetaTag("description", description);
            getOrCreateMetaTag("og:description", description, "property");
        } else {
            removeMetaTag("description");
            removeMetaTag("og:description", "property");
        }

        if (canonical) {
            getOrCreateCanonicalLink().setAttribute("href", canonical);
            getOrCreateMetaTag("og:url", canonical, "property");
        } else {
            const link = document.head.querySelector('link[rel="canonical"]');
            if (link) {
                link.remove();
            }
            removeMetaTag("og:url", "property");
        }

        if (ogImage) {
            getOrCreateMetaTag("og:image", ogImage, "property");
        } else {
            removeMetaTag("og:image", "property");
        }

        if (noindex) {
            getOrCreateMetaTag("robots", "noindex,nofollow");
        } else {
            removeMetaTag("robots");
        }

        if (jsonLd) {
            getOrCreateJsonLdScript().textContent = JSON.stringify(jsonLd);
        } else {
            removeJsonLdScript();
        }
    }, [title, description, canonical, ogImage, noindex, jsonLd]);

    return null;
};

export default Seo;